// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconMarkerS = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='marker-s'
			xmlns='http://www.w3.org/2000/svg'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path
				fill='#999'
				d='M1.756 10.054C4.824 3.946 11.2 0 18 0s13.176 3.946 16.245 10.054c3.33 6.624 1.863 15.164-3.921 22.846L19.07 49.703 18 51.3l-1.07-1.597S5.824 33.123 5.64 32.853c-5.748-7.635-7.215-16.175-3.885-22.8'
			/>
			<path
				fill='#fff'
				stroke='#fff'
				d='M23.27 11.5h2.23v12.333h-1.667v-9.681l-.934 1.634-1.794 3.14L20 17.206zm-11.103 4.396v7.937H10.5V11.5h1.9l6.792 10.189-.95 1.688-5.159-7.758-.916-1.377z'
			/>
		</svg>
	)
}
